
import axios from 'axios'
import { url } from './url'

function updatePreferences(preferences) {
    var urlString = `${process.env.VUE_APP_APIURL}/preferences`;
    return axios
        .put(urlString, preferences)
        .then(res => res.data);
}

function getPartnerUsers() {
    var urlString = `${url}/partnerUser`;
    return axios
        .get(urlString)
        .then(res => res.data);
}

function auth(domain, email, password) {
    return axios.post(`${url}/auth/partner`, { domain: domain, email, password })
        .then(resp => {
            localStorage.setItem('partnerUser', JSON.stringify(resp.data))
            axios.defaults.headers.common['token'] = resp.data.token
            return resp.data
        })
}
function createPartnerUser(partnerUser) {
    var urlString = `${url}/partnerUser`;
    return axios
        .post(urlString, partnerUser)
        .then(res => res.data.id);
}
function updatePartnerUser(partnerUser) {
    var urlString = `${url}/partnerUser/${partnerUser.id}`;
    return axios
        .put(urlString, partnerUser)
        .then(res => res.data._id);
}

function getPartnerSummary(domain) {
    var urlString = `${url}/partner/${domain}/summary`;
    return axios
        .get(urlString)
        .then(res => res.data);
}
function deletePartnerUser(partnerUserId) {
    var urlString = `${url}/partnerUser/${partnerUserId}`;
    return axios
        .delete(urlString)
        .then(res => res.data);
}
export default {
    getPartnerUsers,
    createPartnerUser,
    updatePartnerUser,
    deletePartnerUser,
    getPartnerSummary,
    auth,
    updatePreferences
};